export default [{
  path: '/data/business',
  name: 'Business',
  component: () => import('@/views/admin/business/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Business',
    breadcrumb: [{
        title: 'Home',
        url: '/'
      },
      {
        title: 'Data'
      },
      {
        title: 'Business',
        active: true
      },
    ],
  }
},
{
  path: '/data/business/:id',
  name: 'BusinessData',
  component: () => import('@/views/admin/business/Show.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Business',
    breadcrumb: [{
        title: 'Home',
        url: '/'
      },
      {
        title: 'Data'
      },
      {
        title: 'Business',
        active: true
      },
    ],
  }
}]
